//import { ref } from 'vue'
import { receiveCatalogFile, fetchCatalog, fetchCatalogById, sendCatalog, sendCatalogIsRelease, removeCatalogById } from '../api/serveraccess'

//カタログの取得、登録、編集などの機能を提供する
export default function (){


  const deleteCatalogById = async( id, callback ) => {
    try{
      await removeCatalogById( id )
      callback("success", id)
    }catch(e){
      callback(e)
    }
  }

  const downloadCatalogFile = async( id, waterMark, callback, progressCallback ) => {
    try{
      await receiveCatalogFile( id, waterMark, progressCallback )
      callback("success")
    }catch(e){
      callback(e)
    }
  }

  //商品取得メソッド宣言、非同期メソッドとして宣言
  //sereraccess.jsのメソッドをコール
  const getCatalog = async( callback ) => {
    try{
      var catalogList = await fetchCatalog()
      callback("success", catalogList)
    }catch(e){
      callback(e)
    }
  }

  //商品をIDで指定して取得するメソッド宣言、非同期メソッドとして宣言
  //sereraccess.jsのメソッドをコール
  const getCatalogById = async( id, callback ) =>{
    try{
      console.log( "getCatalogById:" + id )
      var catalog = await fetchCatalogById(id)
      callback("success", catalog)
    }catch(e){
      callback(e)
    }
  }
  
  const updateRelease = async( id, releaseStatus, callback ) => {
    try{
      await sendCatalogIsRelease( id, releaseStatus )
      
      callback("success", id)
    }catch(e){
      callback(e)
    }  
  }

  
  //商品登録、更新メソッド宣言、非同期メソッドとして宣言
  //sereraccess.jsのメソッドをコール
  const registCatalog = async( file, regCatalog, callback, uploadProgressCallback  ) => {
    try{      
      var result = await sendCatalog( file, regCatalog, uploadProgressCallback )
      
      //catalog.value = result
      callback("success", result)
    }catch(e){
      console.log(e)
      callback(e)
    }
  }
 
  //当該ライブラリが提供する変数、メソッドを宣言
  return{
    //catalogList,
    //catalog,
    getCatalog,
    getCatalogById,
    registCatalog,
    downloadCatalogFile,
    updateRelease,
    deleteCatalogById
  }
}